import { useBatchReveal } from "../animations/hooks";
import { useTranslation } from "react-i18next";
import { calculateAge, genderFullName, getRandomStaffData, replaceExceptFirst } from "../helpers/dataHelper";
import { getLanguage } from "../helpers/storageHelper";

function ImageAndDetails(props) {
    const data = props?.data;
    const gridRef = useBatchReveal({ stagger: 0.08 }, [data?.length]);
    const language = getLanguage();
    const {t} = useTranslation();
    const redirectToRandomWhatsApp = (shandeId) => {
        const randomContact = getRandomStaffData("Contact", "Marketing");
        const message = language == 1 ? `你好，我想了解助养计划 (${shandeId})` : `Hi, i would like to know further details about (${shandeId})`;
        const whatsappURL = `https://api.whatsapp.com/send?phone=6${randomContact}&text=${message}`;
        window.open(whatsappURL, "_blank", "noopener,noreferrer");
    }
    return (
        <section className="portfolio-block projects-cards pt-4">
            <div className="container">
                <div className="row" ref={gridRef}>
                    {
                        data && data.map((item, index)=>(
                            <div className="col-md-6 col-lg-3 card-container g-3" data-reveal key={item?.shandeId || index}>
                                <div className="card border-0">
                                    <div className="text-center">
                                        <img className="card-img-top scale-on-hover portrait-img" 
                                        src={item?.pictureLocation} alt={item?.shandeId} />
                                    </div>
                                    <div className="card-body pt-3 pb-0">
                                        <h6>{item?.shandeId}</h6>
                                        <p className="text-muted card-text">
                                            {t("name")}: {replaceExceptFirst(item?.lastName)}
                                            <br/>
                                            {t("gender")}: {genderFullName(item?.gender)}
                                            <br/>
                                            {t("age")}: {calculateAge(item?.dob)} {t("yearsOld")}

                                        </p>
                                        <button className="btn btn-primary" onClick={()=>redirectToRandomWhatsApp(item?.shandeId)}>{t("clickToKnowMe")} <i className="ion-heart"/></button>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    )
}
export default ImageAndDetails;